<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--chevron-right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.323 12 9.03 6.707 9.737 6l6 6-.707.707-5.323 5.323L9 17.323 14.323 12Z" /></svg>
</template>